import { render, staticRenderFns } from "./GlobalAnnouncementsTab.vue?vue&type=template&id=5a2ed54c&scoped=true&"
import script from "./GlobalAnnouncementsTab.vue?vue&type=script&lang=js&"
export * from "./GlobalAnnouncementsTab.vue?vue&type=script&lang=js&"
import style0 from "./GlobalAnnouncementsTab.vue?vue&type=style&index=0&id=5a2ed54c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2ed54c",
  null
  
)

export default component.exports